import ertInputComponent from './ertInput.component';

const ertInput = angular.module('app.common.ertInput', [])
    .component('ertInput', ertInputComponent)
    .name;

export default ertInput;
